var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:10px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1203.66,234.76c56.72,181.81-95.79,111.11-108.7,184.12-59.85,338.34,86.87,866.37-2.59,1242.25l165.39,105.9h-540.38s165.67-107.06,165.67-107.06c-12.64-198.86,61.27-361.05-112.56-414.95,144.85-27.1,137.26-670.74,109.68-826.13-12.97-73.04-165.37-2.29-108.68-184.12h432.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M730.95,232.98v1150c0,14.01,82.47,78.44,53.58,174.19-15.02,22.78-107.67-89.14-107.67-104.5V302.68h-108.18v1184.85h-54.09V232.98h216.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1455.79,232.98v1219.7c0,15.36-92.65,127.27-107.67,104.5-28.9-95.75,53.58-160.18,53.58-174.19V302.68h-108.18v1115.15h-54.09V232.98h216.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.223ce1d8b5d6ea99aed998770826f9dc.svg";
export { ForwardRef as ReactComponent };